import React, { useEffect, useState, lazy } from 'react';
export const CTAButton = ({
  children,
  href = '#precio',
  className = '',
  variant = 'primary'
}: {
  children: React.ReactNode;
  href?: string;
  className?: string;
  variant?: 'primary' | 'outline';
}) => {
  return <a href={href} className={`inline-flex items-center justify-center px-8 py-4 rounded-lg font-bold uppercase transition-all duration-300 text-center cta-shadow cta-animated ${variant === 'primary' ? 'bg-megapack-green text-megapack-bg hover:bg-megapack-greenHover' : 'border-2 border-megapack-cyan text-megapack-cyan hover:bg-megapack-cyan/10'} ${className}`} data-id="element-186">
      {children}
    </a>;
};
export const Countdown = ({
  className = ''
}: {
  className?: string;
}) => {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 57,
    s: 10
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.s > 0) return {
          ...prev,
          s: prev.s - 1
        };
        if (prev.m > 0) return {
          ...prev,
          m: prev.m - 1,
          s: 59
        };
        if (prev.h > 0) return {
          h: prev.h - 1,
          m: 59,
          s: 59
        };
        return {
          h: 23,
          m: 59,
          s: 59
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (n: number) => n.toString().padStart(2, '0');
  return <div className={`flex justify-center items-start gap-2 sm:gap-4 font-mono text-2xl sm:text-4xl md:text-6xl font-bold text-megapack-cyan w-full ${className}`} data-id="element-187">
      <div className="flex flex-col items-center" data-id="element-188">
        <div className="bg-megapack-card border border-megapack-cyan/20 px-3 py-2 sm:p-3 rounded-lg min-w-[60px] sm:min-w-[80px] text-center" data-id="element-189">
          [{format(timeLeft.h)}]
        </div>
        <span className="text-[10px] sm:text-xs text-megapack-gray mt-2 uppercase font-sans" data-id="element-190">
          horas
        </span>
      </div>
      <div className="pt-2 sm:pt-4" data-id="element-191">:</div>
      <div className="flex flex-col items-center" data-id="element-192">
        <div className="bg-megapack-card border border-megapack-cyan/20 px-3 py-2 sm:p-3 rounded-lg min-w-[60px] sm:min-w-[80px] text-center" data-id="element-193">
          [{format(timeLeft.m)}]
        </div>
        <span className="text-[10px] sm:text-xs text-megapack-gray mt-2 uppercase font-sans" data-id="element-194">
          minutos
        </span>
      </div>
      <div className="pt-2 sm:pt-4" data-id="element-195">:</div>
      <div className="flex flex-col items-center" data-id="element-196">
        <div className="bg-megapack-card border border-megapack-cyan/20 px-3 py-2 sm:p-3 rounded-lg min-w-[60px] sm:min-w-[80px] text-center" data-id="element-197">
          [{format(timeLeft.s)}]
        </div>
        <span className="text-[10px] sm:text-xs text-megapack-gray mt-2 uppercase font-sans" data-id="element-198">
          segundos
        </span>
      </div>
    </div>;
};
export const PriceCard = ({
  compact = false
}: {
  compact?: boolean;
}) => {
  const items = ['Módulo 1: Algoritmos y Estructuras', 'Módulo 2: Programación Orientada a Objetos', 'Módulo 3: Base de Datos y SQL', 'Módulo 4: IA como tu Asistente', 'Módulo 5: Cómo Estudiar para Finales', 'Módulo 6: Tu Primer Trabajo en IT', 'Bono 1: Cheat Sheets Python · Java · SQL', 'Bono 2: Planificador de Cuatrimestre', 'Bono 3: 50 Prompts de IA'];
  return <div className="bg-megapack-section border-2 border-megapack-gold rounded-2xl p-6 sm:p-10 shadow-[0_0_30px_-12px_rgba(255,214,0,0.4)] sm:shadow-[0_0_50px_-12px_rgba(255,214,0,0.3)] max-w-2xl mx-auto relative overflow-hidden" data-id="element-199">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 bg-megapack-gold text-megapack-bg font-bold text-xs py-1 px-4 rounded-b-lg uppercase" data-id="element-200">
        ⭐ SISTEMA COMPLETO 2026
      </div>

      <div className="text-center mt-4 mb-8" data-id="element-201">
        <h3 className="text-2xl font-bold mb-1" data-id="element-202">Mega Pack Informática</h3>
        <p className="text-megapack-gray text-sm uppercase tracking-widest" data-id="element-203">
          Pack Completo
        </p>
      </div>

      <div className="flex items-center gap-4 mb-8 bg-megapack-card/50 p-4 rounded-xl border border-white/5" data-id="element-204">
        <img src="https://cdn.magicpatterns.com/uploads/ifDKWjzus6v8ub9qP2rj5t/hf_20260521_012224_a6f83777-a6a3-424a-8f9b-193d8ce478fa-removebg-preview.png" alt="Mega Pack Informática 2026" width="96" height="96" loading="lazy" decoding="async" className="w-24 h-24 object-contain" data-id="element-205" />
        <div className="flex flex-col items-start" data-id="element-206">
          <span className="text-megapack-red line-through text-lg mb-1" data-id="element-207">
            $85.000 ARS
          </span>
          <span className="text-megapack-green text-4xl font-bold" data-id="element-208">
            $19.990 ARS
          </span>
        </div>
      </div>

      <CTAButton href="https://mega-pack-estudiantes-de-informatica.impultienda.ar/checkout" className="w-full text-xl py-6 mb-6" data-id="element-209">
        →LO QUIERO AHORA
      </CTAButton>

      <div className="flex flex-wrap justify-center gap-4 text-[10px] sm:text-xs text-megapack-gray mb-8" data-id="element-210">
        <span data-id="element-211">🔒 Pago seguro</span>
        <span data-id="element-212">⚡ Acceso en 5 min</span>
        <span data-id="element-213">🛡️ Garantía 7 días</span>
        <span data-id="element-214">🇦🇷 Argentina</span>
      </div>

      <div className="space-y-3 border-t border-white/10 pt-8" data-id="element-215">
        {items.map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-216">
            <span className="text-megapack-green text-lg" data-id="element-217">✅</span>
            <span className="text-sm sm:text-base font-medium" data-id="element-218">{item}</span>
          </div>)}
      </div>

      <p className="text-center text-megapack-gray text-xs mt-8" data-id="element-219">
        Pago único · Sin suscripciones mensuales · Acceso de por vida
      </p>
    </div>;
};